import React, { useEffect, useState } from 'react';
import { useAuth } from '../../AuthContext';
import { fetchAccountManagerHistory } from '../../cars/accountManagers';

const formatDateTime = (value) => {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

/** Who has managed this car, newest first. */
const AccountManagerHistory = ({ plate_no }) => {
    const { token } = useAuth();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError('');
        fetchAccountManagerHistory(token, plate_no)
            .then((data) => { if (!cancelled) setRows(data); })
            .catch((err) => { if (!cancelled) setError(err.response?.data?.message || 'Could not load the account manager history. Please refresh the page.'); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [plate_no, token]);

    return (
        <div>
            <h3 className="text-base font-bold text-[#2a2e30] mb-1">Account Managers</h3>
            <p className="text-sm text-gray-500 mb-4">Change the manager from <span className="font-medium">Edit car</span> or <span className="font-medium">Assign Manager</span> on the cars list.</p>

            {loading && <p className="text-sm text-gray-500">Loading history…</p>}
            {error && <p className="text-sm text-red-500">{error}</p>}
            {!loading && !error && rows.length === 0 && (
                <p className="text-sm text-amber-700">No account manager has been assigned to this car yet.</p>
            )}

            {!loading && !error && rows.length > 0 && (
                <div className="overflow-x-auto">
                    <table className="w-full min-w-[560px] text-left text-sm">
                        <thead>
                            <tr className="border-b border-gray-200 text-xs uppercase tracking-wide text-gray-500">
                                <th className="py-2 pr-3 font-semibold">Account Manager</th>
                                <th className="py-2 pr-3 font-semibold">From</th>
                                <th className="py-2 pr-3 font-semibold">To</th>
                                <th className="py-2 pr-3 font-semibold">Assigned By</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row) => (
                                <tr key={row.id} className="border-b border-gray-100">
                                    <td className="py-2 pr-3 font-medium text-[#2a2e30]">
                                        {row.account_manager_name || row.account_manager_username || `User #${row.account_manager_id}`}
                                        {!row.end_date && (
                                            <span className="ml-2 rounded-sm border border-green-200 bg-green-50 px-2 py-0.5 text-[11px] font-semibold text-green-700">Current</span>
                                        )}
                                    </td>
                                    <td className="py-2 pr-3 text-gray-700">{formatDateTime(row.start_date)}</td>
                                    <td className="py-2 pr-3 text-gray-700">{row.end_date ? formatDateTime(row.end_date) : '—'}</td>
                                    <td className="py-2 pr-3 text-gray-700">{row.input_by || '—'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default AccountManagerHistory;
